<div class="container w-100 h-100">
  <div class="text-center mt-5 row justify-content-center">
    <div>
      <h1 class="h3 mb-0 font-weight-normal">{{"login.form.header" | translate}}</h1>
      <ds-log-in
      [isStandalonePage]="true"></ds-log-in>
    </div>
  </div>
</div>
